"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fabricateRedeemCollateral = void 0;
const terra_js_1 = require("@terra-money/terra.js");
const address_1 = require("../../utils/validation/address");
const validate_input_1 = require("../../utils/validate-input");
const true_1 = require("../../utils/validation/true");
const number_1 = require("../../utils/validation/number");
const amount_1 = require("../../utils/validation/amount");
const fabricateRedeemCollateral = ({ address, market, bAsset, amount }) => (addressProvider) => {
    (0, validate_input_1.validateInput)([
        (0, address_1.validateAddress)(address),
        amount ? (0, number_1.validateIsGreaterThanZero)(amount) : true_1.validateTrue,
    ]);
    const bAssetTokenContract = bAsset.token();
    const mmOverseerContract = addressProvider.overseer(market);
    const custodyContract = bAsset.custody();
    return [
        // unlock collateral
        new terra_js_1.MsgExecuteContract(address, mmOverseerContract, {
            // @see https://github.com/Anchor-Protocol/money-market-contracts/blob/master/contracts/overseer/src/msg.rs#L78
            unlock_collateral: {
                collaterals: [
                    [
                        bAssetTokenContract,
                        (0, amount_1.isAmountSet)(amount)
                            ? new terra_js_1.Int(new terra_js_1.Dec(amount).mul(1000000)).toString()
                            : undefined,
                    ],
                ],
            },
        }),
        // withdraw from custody
        new terra_js_1.MsgExecuteContract(address, custodyContract, {
            // @see https://github.com/Anchor-Protocol/money-market-contracts/blob/master/contracts/custody/src/msg.rs#L69
            withdraw_collateral: {
                amount: (0, amount_1.isAmountSet)(amount)
                    ? new terra_js_1.Int(new terra_js_1.Dec(amount).mul(1000000)).toString()
                    : undefined,
            },
        }),
    ];
};
exports.fabricateRedeemCollateral = fabricateRedeemCollateral;
//# sourceMappingURL=redeem-collateral.js.map